'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var whilst = require('async/whilst');

var ConsumableBuffer = require('./consumable-buffer');

module.exports = function wrapHash(hashFn) {
  return function hashing(value) {
    if (value instanceof InfiniteHash) {
      // already a hash. return it
      return value;
    } else {
      return new InfiniteHash(value, hashFn);
    }
  };
};

var InfiniteHash =
/*#__PURE__*/
function () {
  function InfiniteHash(value, hashFn) {
    _classCallCheck(this, InfiniteHash);

    if (typeof value !== 'string' && !Buffer.isBuffer(value)) {
      throw new Error('can only hash strings or buffers');
    }

    this._value = value;
    this._hashFn = hashFn;
    this._depth = -1;
    this._availableBits = 0;
    this._currentBufferIndex = 0;
    this._buffers = [];
  }

  _createClass(InfiniteHash, [{
    key: "take",
    value: function take(bits, callback) {
      var _this = this;

      var pendingBits = bits;
      whilst(function () {
        return _this._availableBits < pendingBits;
      }, function (callback) {
        _this._produceMoreBits(callback);
      }, function (err) {
        if (err) {
          callback(err);
          return; // early
        }

        var result = 0; // TODO: this is sync, no need to use whilst

        whilst(function () {
          return pendingBits > 0;
        }, function (callback) {
          var hash = _this._buffers[_this._currentBufferIndex];
          var available = Math.min(hash.availableBits(), pendingBits);
          var took = hash.take(available);
          result = (result << available) + took;
          pendingBits -= available;
          _this._availableBits -= available;

          if (hash.availableBits() === 0) {
            _this._currentBufferIndex++;
          }

          callback();
        }, function (err) {
          if (err) {
            callback(err);
            return; // early
          }

          process.nextTick(function () {
            return callback(null, result);
          });
        });
      });
    }
  }, {
    key: "untake",
    value: function untake(bits) {
      var pendingBits = bits;

      while (pendingBits > 0) {
        var hash = this._buffers[this._currentBufferIndex];
        var availableForUntake = Math.min(hash.totalBits() - hash.availableBits(), pendingBits);
        hash.untake(availableForUntake);
        pendingBits -= availableForUntake;
        this._availableBits += availableForUntake;

        if (this._currentBufferIndex > 0 && hash.totalBits() === hash.availableBits()) {
          this._depth--;
          this._currentBufferIndex--;
        }
      }
    }
  }, {
    key: "_produceMoreBits",
    value: function _produceMoreBits(callback) {
      var _this2 = this;

      this._depth++;
      var value = this._depth ? this._value + this._depth : this._value;

      this._hashFn(value, function (err, hashValue) {
        if (err) {
          callback(err);
          return; // early
        }

        var buffer = new ConsumableBuffer(hashValue);

        _this2._buffers.push(buffer);

        _this2._availableBits += buffer.availableBits();
        callback();
      });
    }
  }]);

  return InfiniteHash;
}();